module.exports = {
  ASSET_ALLOCATION_SELECTED: 'AssetAllocation/SELECTED',
  COUNTRY_EXPOSURE_SELECTED: 'InvestmentFunds/CountryExposure/SELECTED',
  FETCH_ALTERNATIVE_DOCUMENTS_SUCCESS: 'InvestmentFunds/FETCH_ALTERNATIVE_DOCUMENTS_SUCCESS',
  FUNDBOX_OPENED: 'InvestmentFunds/FUNDBOX_OPENED',
  FUNDBOX_CLOSED: 'InvestmentFunds/FUNDBOX_CLOSED',
  FUNDS_CATALOGUE_SUCCEEDED: 'InvestmentFunds/FUNDS_CATALOGUE_SUCCEEDED',
  FUNDS_FETCH_FAILED: 'InvestmentFunds/FETCH_FAILED',
  FUNDS_FETCH_CATEGORY: 'InvestmentFunds/FUNDS_FETCH_CATEGORY',
  FUNDS_FETCH_REQUESTED: 'InvestmentFunds/FETCH_REQUESTED',
  FUNDS_SET_CLOSE_PRICE: 'InvestmentFunds/FUNDS_SET_CLOSE_PRICE',
  FUNDS_FETCH_SUCCEEDED: 'InvestmentFunds/FETCH_SUCCEEDED',
  GLOBAL_STOCK_SELECTED: 'InvestmentFunds/GlobalStock/SELECTED',
  GROWTH_AMOUNT_CHANGED: 'InvestmentFundsView/Growth/AMOUNT_CHANGED',
  GROWTH_PERIOD_CHANGED: 'InvestmentFundsView/Growth/PERIOD_CHANGED',
  MARKET_CAPITAL_BREAKDOWN_SELECTED: "InvestmentFundsView/marketCapitalBreakdown/SELECTED",
  PROFITABILITY_RANGE_SELECTED: 'InvestmentFundsView/Profitability/RANGE_SELECTED',
  PROFIT_RISK_OPTION_SELECTED: 'InvestmentFundsView/ProfitRisk/OPTION_SELECTED',
  TAB_SWITCHED: 'InvestmentFundsView/Tabs/SWITCHED',
  FUNDS_FETCH_SUB_CATEGORIES: 'InvestmentFundsView/FUNDS_FETCH_SUB_CATEGORIES',
  FUNDS_FETCH_MINIMUN_DETAILS: 'InvestmentFundsView/FUNDS_FETCH_MINIMUN_DETAILS',
  BROKER_PRODUCT_ADVANCED_SEARCH_LINK_NAME_TRACKING: 'BROKER_PRODUCT_ADVANCED_SEARCH_LINK_NAME_TRACKING',
};
